export default function HeroCard11() {
  return (
    <>
      <section className="pet-hero-pure">

        {/* Background dotted pattern */}
        <svg className="dots-pattern" width="100%" height="100%" viewBox="0 0 800 600">
          <defs>
            <pattern id="dots" width="26" height="26" patternUnits="userSpaceOnUse">
              <circle cx="3" cy="3" r="2" fill="rgba(0,0,0,0.05)" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#dots)" />
        </svg>

        {/* Soft particles */}
        <div className="p p1"></div>
        <div className="p p2"></div>
        <div className="p p3"></div>

        {/* Layered Curved Ribbon */}
        <div className="curve-wrap">
          <div className="curve back"></div>
          <div className="curve mid"></div>
          <div className="curve front">  <div className="main-img">
              <img src="https://i.postimg.cc/fb0Gq22L/cheerful-student-posing-against-pink-wall-with-glasses.jpg" />
            </div></div>

          <div className="curve-glow"></div>
        </div>

        <div className="pet-container">

          {/* LEFT TEXT */}
          <div className="left fadeUp">
            <p className="pre">WELCOME TO PETS HOME</p>

            <h1 className="title">
              We love pets <br />
              because they love us <span>to</span>
            </h1>

            <p className="desc">
              It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.
            </p>

            <button className="btn-main">Discover More</button>
          </div>

          {/* RIGHT VISUALS */}
          <div className="right">

            {/* Main Image */}
          

            {/* Floating Thumbnails */}
            <div className="thumb t1 shine float">
              <img src="https://i.postimg.cc/g2v3W5z5/red-haired-lady-eyeglasses-holds-books-shows-ok-sign.jpg" />
            </div>

            <div className="thumb t2 shine floatSlow">
              <img src="https://i.postimg.cc/G24xxVq7/smiling-pensive-brunette-schoolgirl-with-long-hair-hugging-book.jpg" />
            </div>

            <div className="thumb t3 shine floatDelay">
              <img src="https://i.postimg.cc/NjR1gXDD/young_tender_curly_girl_holding_documents_removebg_preview.png" />
            </div>

           

            {/* Info card */}
            <div className="info-card floatSlow">
              <h3>1.2K</h3>
              <p>Adopted Pets</p>
            </div>

          </div>

        </div>
      </section>

      <style>{`
/* ---------------- CORE LAYOUT ---------------- */
.pet-hero-pure {
  position: relative;
      
  padding: 90px 0 120px;
  background: #ffffff;
  font-family: Inter, sans-serif;
}

/* dotted background */
.dots-pattern {
  position: absolute;
  inset: 0;
  opacity: .15;
  pointer-events: none;
}

/* ---------------- PARTICLES ----------------*/
.p {
  position: absolute;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255,120,60,0.16), rgba(255,120,60,0.02));
  filter: blur(6px);
  pointer-events: none;
  animation: floatP 7s ease-in-out infinite;
}
.p1 { top: 12%; left: 5%; }
.p2 { top: 30%; right: 10%; animation-delay: .4s; }
.p3 { bottom: 8%; right: 14%; animation-delay: .8s; }

@keyframes floatP {
  0% { transform: translateY(0); }
  50% { transform: translateY(-18px); }
  100% { transform: translateY(0); }
}

/* -------------- CURVED LAYER RIBBON -------------- */
.curve-wrap {
  position: absolute;
  right: -35%;
  top: -8%;
  width: 1100px;
  height: 1100px;
  pointer-events: none;
  z-index: 1;
}

.curve {
  position: absolute;
  inset: 0;
  border-radius: 50%;
}

.back { background: #fff3ea; transform: scale(1.02); }
.mid  { background: #ffd3b3; transform: scale(0.92); }
.front{ background: #ff6f3f; transform: scale(0.82);overflow:hidden;position:relative; }

/* glowing aura behind ribbon */
.curve-glow {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255,110,60,0.35), transparent 60%);
  filter: blur(32px);
}

/* -------------- INNER GRID -------------- */
.pet-container {
  width: 92%;
  max-width: 1250px;
  margin: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  z-index: 4;
  position: relative;
}

/* ---------------- LEFT ---------------- */
.left .pre {
  font-size: 15px;
  font-weight: 700;
  color: #666;
  margin-bottom: 12px;
}

.title {
  font-size: 48px;
  font-weight: 900;
  line-height: 1.1;
  margin-bottom: 16px;
}
.title span {
  display: inline-block;
  opacity: .9;
}

.desc {
  font-size: 17px;
  color: #555;
  margin-bottom: 25px;
  max-width: 80%;
}

.btn-main {
  background: #111;
  padding: 14px 26px;
  border-radius: 12px;
  font-weight: 700;
  color: #fff;
  border: none;
  cursor: pointer;
  transition: .3s;
}
.btn-main:hover {
  background: #000;
  transform: translateY(-3px);
}

/* ---------------- RIGHT ---------------- */


/* main portrait */
.main-img {margin:50px; border-radius:50%;
  position:absolute;top:0px;left:0px;right:0px;bottom:0px;
  border-radius: 18px;
  overflow: hidden;
 
  position: relative;
  z-index: 5;
  animation: fadeUp .9s ease both;
}
.main-img img {aspect-ratio:2/1.5;border-radius:50%;
   object-fit: cover;
}

/* ---------------- FLOATING THUMBS ---------------- */
.thumb, .mini {
  position: absolute;
  width: 120px;padding:20px;
  height: 120px;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0 18px 50px rgba(0,0,0,0.18);
  animation: float 5s ease-in-out infinite;
}
.thumb img, .mini img { width:100%; height:100%;border-radius:50%; object-fit:cover; }

/* positions */
.t1 { top: 18%; right: -60px; }
.t2 { top: 52%; right: -70px; }
.t3 { bottom: 10%; right: 20px; }
.mini { bottom: -20px; left: 40px; width: 95px; height:95px; }

/* Info card */
.info-card {
  position: absolute;
  right: -40px; bottom: 180px;
  background: #fff;
  padding: 14px 18px;
  border-radius: 16px;
  box-shadow: 0 14px 40px rgba(0,0,0,.16);
  animation: float 6s ease-in-out infinite;
}
.info-card h3 {
  margin: 0;
  font-size: 28px;
  font-weight: 800;
  color: #ff6f3f;
}
.info-card p {
  margin: 0;
  font-size: 14px;
  color: #444;
}

/* -------------- Shine Sweep Hover -------------- */
.shine {
  position: relative;
}
.shine::before {
  content:"";
  position:absolute;
  inset:0;
  background:linear-gradient(120deg,
    transparent 0%,
    rgba(255,255,255,0.4) 45%,
    rgba(255,255,255,0.8) 50%,
    rgba(255,255,255,0.4) 55%,
    transparent 100%
  );
  transform: translateX(-150%);
  transition: transform .8s ease-out;
}
.shine:hover::before {
  transform: translateX(150%);
}

/* ---------------- Animations ---------------- */
@keyframes float {
  0% { transform: translateY(0); }
  50% { transform: translateY(-14px); }
  100% { transform: translateY(0); }
}

.floatSlow { animation-duration: 6.5s; }
.floatDelay { animation-delay: .4s; }
.floatDelay2 { animation-delay: .8s; }

.fadeUp {
  opacity:0;
  animation: fadeUp .8s ease forwards;
}
@keyframes fadeUp {
  from { opacity:0; transform:translateY(20px); }
  to   { opacity:1; transform:translateY(0); }
}

/* ---------------- RESPONSIVE ---------------- */
@media (max-width: 980px) {
  .pet-container {
    grid-template-columns: 1fr;
  }
  .right { margin-top: 40px; }
  .main-img { width:100%; height:auto; }
  .thumb, .mini, .info-card { display:none; }
}
      `}</style>
    </>
  );
}
